export default "__VITE_PUBLIC_ASSET__701b256a__"